import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
`;

export const Label = styled.div`
  color: #1a1b1c;
  font-size: 16px;
`;

export const Column = styled.div``;
